@if (detailsForm; as form) {
  <form
    class="grid grid-cols-4 gap-x-4 rounded-2xl bg-neutral-0 p-4 shadow-md"
    [formGroup]="form"
  >
    <div class="col-span-2 flex flex-col">
      <div class="mb-4 w-full rounded-lg bg-neutral-100 p-2 font-thin">
        <prescriptions-icon [prescriptionType]="planningDetails()?.serviceType"></prescriptions-icon>
        <p class="text-lg font-bold">{{ planningDetails()?.serviceName }}</p>
      </div>

      <div class="-mb-4 flex items-start gap-4">
        <div class="flex w-1/2 flex-col">
          <mat-form-field class="w-full">
            <mat-label>{{ "appointments.label.doctorName" | translate }}</mat-label>
            <input
              matInput
              readonly
              type="text"
              [formControl]="form.controls.doctorName"
            />
          </mat-form-field>

          <div class="flex items-start gap-4">
            <mat-form-field class="w-full">
              <mat-label>{{ "appointments.label.date" | translate }}</mat-label>
              <input
                matInput
                readonly
                [formControl]="form.controls.date"
                [matDatepicker]="datePicker"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="datePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #datePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="w-full">
              <mat-label>{{ "appointments.label.time" | translate }}</mat-label>
              <input
                matInput
                readonly
                type="time"
                [formControl]="form.controls.time"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="flex w-1/2 flex-col">
          <prescriptions-appointment-status-control
            [formControl]="form.controls.status"
            [originalStatus]="planningDetails()?.status"
          ></prescriptions-appointment-status-control>

          @if (form.controls.status.value === "Cancelled") {
            <mat-form-field class="w-full">
              <mat-label>{{ "appointments.label.cancellationReason" | translate }}</mat-label>
              <input
                matInput
                readonly
                type="text"
                [formControl]="form.controls.statusReason"
              />
            </mat-form-field>
          }
        </div>
      </div>
    </div>

    <div class="col-span-1 -mb-4 flex flex-col justify-between">
      <mat-form-field class="w-full">
        <mat-label>{{ "appointments.label.city" | translate }}</mat-label>
        <input
          matInput
          readonly
          type="text"
          [formControl]="form.controls.city"
        />
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>{{ "appointments.label.partnerName" | translate }}</mat-label>
        <input
          matInput
          readonly
          type="text"
          [formControl]="form.controls.partnerName"
        />
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>{{ "appointments.label.departmentName" | translate }}</mat-label>
        <input
          matInput
          readonly
          type="text"
          [formControl]="form.controls.locationName"
        />
      </mat-form-field>
    </div>

    <div class="col-span-1">
      <div class="h-full w-full rounded-2xl border-2 border-dashed border-neutral-200 p-4">
        <div class="flex items-center gap-2 text-sm">
          <div class="w-24 text-neutral-300">{{ "appointments.label.address" | translate }}</div>
          <span>{{ form.controls.address.value }}</span>
        </div>
        <div class="flex items-center gap-2">
          <div class="w-24 text-sm text-neutral-300">{{ "appointments.label.phoneNumber" | translate }}</div>
          <div class="col-span-3">{{ planningDetails()?.locationPhoneNumber ?? "-" }}</div>
        </div>
        <div class="flex items-center gap-2">
          <div class="w-24 text-sm text-neutral-300">{{ "appointments.label.email" | translate }}</div>
          <div class="col-span-3">{{ planningDetails()?.locationEmail ?? "-" }}</div>
        </div>
      </div>
    </div>
  </form>
} @else {
  <div class="col-span-8 flex h-[196px] w-full items-center justify-center rounded-2xl bg-neutral-0 p-4 shadow-md">
    <shared-loader></shared-loader>
  </div>
}
